import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-4" }, "Found Evidence", -1)
const _hoisted_2 = { class: "field-label is-normal" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "field-body" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "select" }
const _hoisted_8 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", null, null, -1)
const _hoisted_10 = { class: "field is-horizontal" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, null, -1)
const _hoisted_12 = { class: "field-body" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evidence, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "field is-horizontal",
        key: item.number
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", {
            class: "label",
            for: 'evidence-selector-' + item.number
          }, " Evidence #" + _toDisplayString(item.number), 9, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  id: 'evidence-selector-' + item.number,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEvidenceChanged && _ctx.onEvidenceChanged(...args))),
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                  disabled: item.disabled
                }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.evidenceOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", { key: option }, _toDisplayString(option), 1))
                  }), 128))
                ], 40, _hoisted_8), [
                  [_vModelSelect, item.value]
                ])
              ])
            ])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetEvidence && _ctx.resetEvidence(...args))),
              class: "button is-link"
            }, "Reset")
          ])
        ])
      ])
    ])
  ], 64))
}